import React, { useMemo } from 'react'
import classnames from 'classnames'
import shuffle from 'lodash/shuffle'

import avatar1 from 'assets/images/blurred-avatars/1.png'
import avatar2 from 'assets/images/blurred-avatars/2.png'
import avatar3 from 'assets/images/blurred-avatars/3.png'
import avatar4 from 'assets/images/blurred-avatars/4.png'
import avatar5 from 'assets/images/blurred-avatars/5.png'
import avatar6 from 'assets/images/blurred-avatars/6.png'
import avatar7 from 'assets/images/blurred-avatars/7.png'
import avatar8 from 'assets/images/blurred-avatars/8.png'
import avatar9 from 'assets/images/blurred-avatars/9.png'
import avatar10 from 'assets/images/blurred-avatars/10.png'
import avatar11 from 'assets/images/blurred-avatars/11.png'
import avatar12 from 'assets/images/blurred-avatars/12.png'

const avatarList = [
  avatar1,
  avatar2,
  avatar3,
  avatar4,
  avatar5,
  avatar6,
  avatar7,
  avatar8,
  avatar9,
  avatar10,
  avatar11,
  avatar12,
]

const DISPLAY_AVATARS = 3

const Avatar = ({ src, className, ...rest }) => (
  <img
    src={src}
    alt="avatar"
    className={classnames(
      'rounded-full w-6 h-6 border border-solid border-midnightBlack',
      className
    )}
    {...rest}
  />
)

const BlurredAvatars = () => {
  const avatars = useMemo(() => shuffle(avatarList).slice(0, DISPLAY_AVATARS), [])

  return (
    <div className="relative flex items-center">
      {avatars.map((avatar, index) => (
        <Avatar
          key={index}
          src={avatar}
          className="absolute"
          style={{
            left: index * 3 * 4,
            zIndex: DISPLAY_AVATARS - index,
          }}
        />
      ))}
    </div>
  )
}

export default BlurredAvatars
